const addFocusKey = (item, index) => {
  return {
    ...item,
    focusKey: `${index}-${item.key}`,
  }
}

export default addFocusKey
